import React from 'react'

export const Wallet: React.FC<{ fill?: string }> = ({
  fill = 'var(--button-fg)',
}) => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2.5V2C14 0.90625 13.0938 0 12 0H3C1.3125 0 0 1.34375 0 3V11C0 12.6875 1.3125 14 3 14H14C15.0938 14 16 13.125 16 12V4.5C16 3.40625 15.0938 2.5 14 2.5ZM14.5 12C14.5 12.2812 14.25 12.5 14 12.5H3C2.15625 12.5 1.5 11.8438 1.5 11V3C1.5 2.1875 2.15625 1.5 3 1.5H12C12.25 1.5 12.5 1.75 12.5 2V3H3.5C3.21875 3 3 3.25 3 3.5C3 3.78125 3.21875 4 3.5 4H14C14.25 4 14.5 4.25 14.5 4.5V12ZM12 7C11.4375 7 11 7.46875 11 8C11 8.5625 11.4375 9 12 9C12.5312 9 13 8.5625 13 8C13 7.46875 12.5312 7 12 7Z" fill={fill} />
  </svg>
)
